<template>
  <div>
    <ModalGlobal id="modalAddEmail" v-if="$store.state.componentes.modalLogin"
      @close-modal="$store.dispatch('setModalLogin', false);" class="AuthModal">
      <template #dialogHeadImg>
        <img class="absolute h-22 -top-12 left-0 right-0 m-auto pointer-events-none"
          src="https://photo-public.s3.amazonaws.com/suf/home/photo-pass-logo.png" alt="Grupo Xcaret | Foto"
          title="Grupo Xcaret | Foto" />
      </template>

      <template #dialogDescription>
        <section id="formsButton" class="container mx-auto">
          <WizardCreateAuth v-if="authOptions.includes(getModalAuth)" />
          <!-- Login -->
          <div id="formFolio" class="w-full md:w-2/5 mt-4 mx-auto px-4 md:px-0 md:min-w-124" v-if="getModalAuth == 1">
            <div class="title uppercase text-center font-bold">
              {{ $t("Forms.login_account") }}
            </div>
            <p class="text-sm mt-3 mb-3 px-8 w-full relative text-center">
              {{ $t("Forms.login_message") }}
            </p>

            <LoginForm />

            <p class="py-3 text-center">
              <a @click.prevent="loggedProcess" class="font-semibold underline cursor-pointer text-newxcaret-blue">
                {{ $t("Forms.login_guest") }}
              </a>
            </p>
          </div>

          <!-- Create account -->
          <RegisterForm v-if="getModalAuth == 2" />

          <!-- Active account -->
          <ActiveForm v-if="getModalAuth == 3" />

          <!-- Resend access code -->
          <ResendAccessCodeForm v-if="getModalAuth == 4" />

          <!-- Recover account -->
          <RecoverAccountForm v-if="getModalAuth == 5" />

          <!-- Forgot password -->
          <ForgotForm v-if="getModalAuth == 6" />

        </section>
      </template>
    </ModalGlobal>
  </div>

</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import "@components/validators/index.js";

import AlbumsMix from "@mixins/albums/GetAlbumsByEmail.js";
import LoginForm from "@forms/auth/Login.vue";
import RegisterForm from "@forms/auth/Register.vue";
import ActiveForm from "@forms/auth/Active.vue";
import ResendAccessCodeForm from "@forms/auth/ResendAccessCode.vue";
import RecoverAccountForm from "@forms/auth/RecoverAccount.vue";
import ForgotForm from "@forms/auth/Forgot.vue";
import WizardCreateAuth from "@components/partials/WizardCreate.vue";

export default {
  props: [],
  mixins: [AlbumsMix],
  components: { LoginForm, RegisterForm, ActiveForm, ResendAccessCodeForm, RecoverAccountForm, ForgotForm, WizardCreateAuth },
  data: () => ({
    form: {
      email: "",
    },
    authOptions: [2, 3]
  }),
  computed: {
    // Acceder al state de 'auth' module
    ...mapState('auth', ['modalAuth']),

    // Usar getters de 'auth' module
    ...mapGetters('auth', ['getModalAuth']),
  },
  methods: {
    // Usar acciones de 'auth' module
    ...mapActions('auth', ['setModalAuth']),
    /**
     * @description Submit the form
    */
    async submit() {
      await this.loggedProcess();
    },
    /**
     * @description Set the user as logged by email
     */
    async loggedProcess() {
      this.$store.dispatch("setAuthGuest");
    },
  },
  created() { },
  mounted() { },
};
</script>
